import React from 'react';
import { MapPin, MessageCircle, Mail, Clock, Instagram, Star, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const INSTAGRAM_URL = 'https://instagram.com/dentico_clinic';
const LEAVE_REVIEW_URL = 'https://g.page/r/CUmhstMLWUqlEBM/review';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-287" data-mp="38h81hlebwon">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-288" data-mp="36d44znhyxod" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const leaveReviewText = lang === 'en' ? 'Leave a Review' : lang === 'ua' ? 'Залишити відгук' : lang === 'ro' ? 'Lăsați o recenzie' : 'Оставить отзыв';
  return <footer className="bg-forest-600 text-ivory/70 py-14 border-t border-white/10" data-id="element-289" data-mp="34p6j01lngek">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290" data-mp="htczqznz3e1c">
        {/* Brand wordmark */}
        <div className="mb-12" data-id="element-291" data-mp="ct75rcu8dfg3">
          <Link to={`/${lang}`} className="inline-flex flex-col leading-none" data-id="element-292" data-mp="cv1pwoxoh3j4">
            <span className="text-2xl font-semibold tracking-[0.22em] text-white" style={{
            fontFamily: '"Playfair Display", Georgia, serif'
          }} data-id="element-293" data-mp="qsqfga2owyui">
              DENTICO
            </span>
            <span className="block text-right text-[10px] tracking-[0.4em] text-white uppercase mt-1" data-id="element-294" data-mp="tta0yjibn3yt">
              Clinic
            </span>
          </Link>
          <p className="text-sm text-ivory/60 mt-4 max-w-xs" data-id="element-295" data-mp="13sirf2dza0gf">
            {lang === 'en' ? 'Private dental clinic in Angel, Islington, London.' : lang === 'ua' ? 'Приватна стоматологічна клініка в Angel, Islington, Лондон.' : lang === 'ro' ? 'Clinică dentară privată în Angel, Islington, Londra.' : 'Частная стоматологическая клиника в Angel, Islington, Лондон.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-296" data-mp="1rhttqoaz82wo">
          {/* Location */}
          <div className="space-y-4" data-id="element-297" data-mp="3obx27dr50yve">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-298" data-mp="3oczot9hfgf5i">
              {t('footer.location')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-299" data-mp="2af3r7lrdkvhi">
              <MapPin className="w-5 h-5 text-beige mt-0.5 shrink-0" strokeWidth={1.75} data-id="element-300" data-mp="2afx1gwpjm34e" />
              <div data-id="element-301" data-mp="25mkess4fc6ea">
                <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-302" data-mp="21mjzz6dext6p">
                  <p className="text-ivory/80" data-id="element-303" data-mp="2tdg3hgdl2lhb">{t('footer.address')}</p>
                  <p className="text-ivory/60" data-id="element-304" data-mp="2pc4lnx0yb4jo">Angel, Islington</p>
                </a>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-305" data-mp="2fe6yzdyqpft6">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-306" data-mp="2fd5ao7spqwti">
              {t('footer.contact')}
            </h3>
            <div className="space-y-3" data-id="element-307" data-mp="18zph2dw8v1vc">
              <a href="tel:+447345197820" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-308" data-mp="13z1in75orir3">
                <Phone className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-309" data-mp="2rug4rihkxmpt" />
                <span data-id="element-310" data-mp="2wnhktttivsaz">07345 197820</span>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-311" data-mp="2iv1herwpls9j">
                <MessageCircle className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-312" data-mp="3bjgsx4gmtsg4" />
                <span data-id="element-313" data-mp="3fkitppq76ck7">{t('footer.whatsappChat')}</span>
              </a>
              <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-314" data-mp="31khjhjo1lss2">
                <TelegramIcon className="w-5 h-5 text-beige" data-id="element-315" data-mp="1q52oglfe9azl" />
                <span data-id="element-316" data-mp="1v6i6e4m9z1dr">Telegram</span>
              </a>
              <a href="mailto:info@denticoclinic.co.uk" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-317" data-mp="1v346d313349h">
                <Mail className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-318" data-mp="1iml9w0snv5zr" />
                <span data-id="element-319" data-mp="1wlktgu1bgup2">info@denticoclinic.co.uk</span>
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-320" data-mp="1rn19gz6a9szc">
                <Instagram className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-321" data-mp="zxoc3my21vcs" />
                <span data-id="element-322" data-mp="1do1kfqeuzc2n">@dentico_clinic</span>
              </a>
              <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors text-beige" data-id="element-323" data-mp="1dpmhpnsk5947">
                <Star className="w-5 h-5" strokeWidth={1.75} data-id="element-324" data-mp="g7cmw8wxyvz2" />
                <span data-id="element-325" data-mp="2gan7y10w7kzq">{t('reviews.leaveReview')}</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-326" data-mp="2l8yhsbr6tvhy">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-327" data-mp="2l7vv6g0wef7u">
              {t('footer.hours')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-328" data-mp="2q2t13e2vs8gi">
              <Clock className="w-5 h-5 text-beige mt-0.5 shrink-0" strokeWidth={1.75} data-id="element-329" data-mp="2uy8bfw1ojm86" />
              <div className="space-y-2 text-sm w-full" data-id="element-330" data-mp="1xdvq7w101dxs">
                <div className="flex justify-between gap-4" data-id="element-331" data-mp="22bxagka5vjau">
                  <span className="text-ivory/60" data-id="element-332" data-mp="27a77l0fg4tz3">{t('footer.monFri')}</span>
                  <span className="text-white" data-id="element-333" data-mp="27c1qyab2ke12">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-334" data-mp="2bcvj5fvjoezr">
                  <span className="text-ivory/60" data-id="element-335" data-mp="3io2mc82fv0ps">{t('footer.saturday')}</span>
                  <span className="text-white" data-id="element-336" data-mp="3mq6c81puu7ul">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-337" data-mp="1b3chm7yvna5u">
                  <span className="text-ivory/60" data-id="element-338" data-mp="1b2knl1kxhkho">{t('footer.sunday')}</span>
                  <span className="text-white" data-id="element-339" data-mp="17323u94uffgf">{t('footer.closed')}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4" data-id="element-340" data-mp="xch7kscn6n0o">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-341" data-mp="xbfvqlnsxwhw">
              {t('footer.legal.title')}
            </h3>
            <div className="flex flex-col space-y-2" data-id="element-342" data-mp="sarxpg15ofe6">
              <Link to={`/${lang}/privacy-policy`} className="hover:text-white transition-colors" data-id="element-343" data-mp="ncqbim8fnzyh">
                {t('footer.legal.privacyPolicy')}
              </Link>
              <Link to={`/${lang}/cookie-policy`} className="hover:text-white transition-colors" data-id="element-344" data-mp="eeo49oy3wb2r">
                {t('footer.legal.cookiePolicy')}
              </Link>
              <Link to={`/${lang}/patient-privacy-notice`} className="hover:text-white transition-colors" data-id="element-345" data-mp="28rw6w2sbpqyy">
                {t('footer.legal.patientPrivacy')}
              </Link>
              <Link to={`/${lang}/terms-and-conditions`} className="hover:text-white focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory/60 rounded-sm transition-colors" data-id="element-346" data-mp="17vytfm5j696u">
                {t('footer.legal.terms')}
              </Link>
            </div>
          </div>
        </div>

        {/* Compact Contact Line */}
        <div className="border-t border-white/10 mt-12 pt-6" data-id="element-347" data-mp="oxcsq8dxek3g">
          <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-sm text-ivory/60" data-id="element-348" data-mp="oz7f7r4uik9n">
            <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-349" data-mp="ty0t3ko1odac">
              360–364 City Rd, London EC1V 2PY
            </a>
            <span className="text-ivory/30" data-id="element-350" data-mp="cn53ths99rc7">·</span>
            <a href="tel:+447345197820" className="hover:text-white transition-colors" data-id="element-351" data-mp="7ojzp79vunih">
              07345 197820
            </a>
            <span className="text-ivory/30" data-id="element-352" data-mp="hlyhba7jlicd">·</span>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-353" data-mp="hl6lpzdy3km3">
              WhatsApp
            </a>
            <span className="text-ivory/30" data-id="element-354" data-mp="qgmj2qdwshwf">·</span>
            <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-355" data-mp="15ahotnirpr3e">
              Telegram
            </a>
            <span className="text-ivory/30" data-id="element-356" data-mp="3735rnvri2cin">·</span>
            <a href="mailto:info@denticoclinic.co.uk" className="hover:text-white transition-colors" data-id="element-357" data-mp="324kts2zq04xd">
              Email
            </a>
            <span className="text-ivory/30" data-id="element-358" data-mp="dvf7mybe9rw5">·</span>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-359" data-mp="dtkmbiw7nxrj">
              Instagram
            </a>
            <span className="text-ivory/30" data-id="element-360" data-mp="11kqbioo1k2ei">·</span>
            <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-beige" data-id="element-361" data-mp="11jexlw0vte9o">
              {leaveReviewText}
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-center text-sm text-ivory/40" data-id="element-362" data-mp="mvaljawc40zv">
          <p data-id="element-363" data-mp="1kbhffap9f0li">
            &copy; {new Date().getFullYear()} Dentico Clinic.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}